











































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Prop, Vue } from "vue-property-decorator";
import Service from "@/services/PemantauanAnestesi";
import { storePemantauanAnestesi as PemantauanAnestesiStore } from "@/store/modules/PemantauanAnestesiStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storePerawat } from "@/store/modules/perawat";
import { storeDokter } from "@/store/modules/dokter";
import PersonAutoComplete from "@/components/PersonAutoComplete.vue";
import { userModule } from "@/store/modules/user";

function emptyObatRow() {
  return { obat: "", dosis: "", rute: "" };
}

function emptyWaktuRow() {
  return { pukul: "", keterangan: "" };
}

function emptyObatPukulRow() {
  return { nama: "", dosis: "", pukul: "" };
}

function emptyKumulatifRow() {
  return { nama: "", dosis: "" };
}

@Component({
  components: { PersonAutoComplete }
})
export default class PemantauanAnestesiPage extends Vue {
  @Prop() register: string;
  @Prop() rm: string;

  loading = false;
  saving = false;
  recordId: number = null;
  record: any = null;

  // Grafik dialog
  grafikDialog = false;
  grafikDialogNilai = 0;
  grafikDialogKolom = 0;
  grafikDialogSimbol = "";

  // Grafik config
  skalaGrafik = [240, 230, 220, 210, 200, 190, 180, 170, 160, 150, 140, 130, 120, 110, 100, 90, 80, 70, 60, 50, 40, 30, 20, 10, 0];
  jumlahKolomGrafik = 20;

  polaNafasOptions = [
    { text: "S+ (Spontan)", value: "S+" },
    { text: "D+ (Dibantu)", value: "D+" },
    { text: "K+ (Kendali)", value: "K+" }
  ];

  form = {
    // Identitas tindakan
    diagnosa_pra_bedah: "",
    diagnosa_pasca_bedah: "",
    jenis_pembedahan: "",
    operator_nama: "",
    dr_anestesi_user_id: null as number | null,
    perawat_anestesi_user_id: null as number | null,

    // Asesmen pra induksi
    td_sistole: "",
    td_diastole: "",
    nadi: "",
    bb: "",
    tb: "",
    penyakit_penyerta: "",
    alergi: "",
    asma: "",

    // Lab
    lab_hb: "",
    lab_al: "",
    lab_at: "",
    lab_hmt: "",
    lab_pt: "",
    lab_aptt: "",
    lab_gd: "",
    lab_elektrolit: "",

    // Status ASA & Checklist
    status_asa: "",
    inform_consent: "",
    kesiapan_anestesi: "",

    // Premedikasi & Induksi
    premedikasi: Array.from({ length: 2 }, emptyObatRow),
    induksi: Array.from({ length: 3 }, emptyObatRow),

    // Teknik Anestesi
    teknik_anestesi: "",
    regional_posisi: "",
    regional_daerah: "",
    regional_jarum_no: "",
    regional_catheter_epidural: false,
    regional_obat: "",
    umum_tiva: false,
    umum_airway: "",
    umum_pemeliharaan: "",
    umum_pernafasan: "",

    // Agen Anestesi
    agen_haloth_etern_iso_sevo: "",
    agen_n2o: "",
    agen_o2: "",

    // Waktu & Obat
    waktu_pukul: Array.from({ length: 6 }, emptyWaktuRow),
    obat_pukul: Array.from({ length: 6 }, emptyObatPukulRow),

    // Infus
    infus: ["", "", "", ""],

    // Monitoring
    frekuensi_nafas: "",
    pola_nafas: "",
    saturasi: "",

    // Waktu operasi & anestesi
    mulai_anestesi: "",
    akhir_anestesi: "",
    mulai_operasi: "",
    akhir_operasi: "",

    // Grafik vital
    grafik_vital: [] as any[],

    // Cairan masuk
    cairan_masuk_kristaloid: "",
    cairan_masuk_koloid: "",
    cairan_masuk_komponen: "",
    cairan_masuk_total: "",

    // Cairan keluar
    cairan_keluar_darah: "",
    cairan_keluar_urin: "",
    cairan_keluar_total: "",

    // Kumulatif obat
    kumulatif_obat: Array.from({ length: 4 }, emptyKumulatifRow),

    // Catatan
    catatan_durante: ""
  };

  get currentUser() {
    return userModule.user;
  }

  get canSave(): boolean {
    const action = (this as any).recordId ? "edit" : "create";
    return userModule.canAccessForm("pemantauan_anestesi", action);
  }

  get dokterList() {
    return storeDokter.listAll || [];
  }

  get perawatList() {
    return storePerawat.listPerawat || [];
  }

  mounted() {
    if (!storePerawat.listPerawat.length) {
      storePerawat.actListPerawatall();
    }
    if (!storeDokter.listAll.length) {
      storeDokter.act_dokter_all();
    }
    if (this.register) {
      this.loadData();
    }
  }

  async loadData() {
    this.loading = true;
    try {
      await PemantauanAnestesiStore.getByRegister(this.register);
      const record = PemantauanAnestesiStore.record;
      if (record) {
        this.record = record;
        this.recordId = record.id;
        this.populateForm(record);
      }
      // Auto-fill dokter anestesi dari current user jika belum ada
      if (!this.form.dr_anestesi_user_id && this.currentUser && this.currentUser.id) {
        this.form.dr_anestesi_user_id = this.currentUser.id;
      }
    } finally {
      this.loading = false;
    }
  }

  populateForm(data) {
    // Content berisi semua data form
    const content = data.content || {};

    // Top-level fields
    if (data.dr_anestesi_user_id) this.form.dr_anestesi_user_id = data.dr_anestesi_user_id;
    if (data.perawat_anestesi_user_id) this.form.perawat_anestesi_user_id = data.perawat_anestesi_user_id;

    // Content fields
    const fields = Object.keys(this.form);
    fields.forEach(key => {
      if (key === "dr_anestesi_user_id" || key === "perawat_anestesi_user_id") return;
      if (content[key] === undefined || content[key] === null) return;

      if (key === "premedikasi") {
        const rows = content[key] || [];
        this.form.premedikasi = Array.from({ length: 2 }, (_, i) => rows[i] || emptyObatRow());
      } else if (key === "induksi") {
        const rows = content[key] || [];
        this.form.induksi = Array.from({ length: 3 }, (_, i) => rows[i] || emptyObatRow());
      } else if (key === "waktu_pukul") {
        const rows = content[key] || [];
        this.form.waktu_pukul = Array.from({ length: 6 }, (_, i) => rows[i] || emptyWaktuRow());
      } else if (key === "obat_pukul") {
        const rows = content[key] || [];
        this.form.obat_pukul = Array.from({ length: 6 }, (_, i) => rows[i] || emptyObatPukulRow());
      } else if (key === "kumulatif_obat") {
        const rows = content[key] || [];
        this.form.kumulatif_obat = Array.from({ length: 4 }, (_, i) => rows[i] || emptyKumulatifRow());
      } else if (key === "infus") {
        const arr = content[key] || [];
        this.form.infus = Array.from({ length: 4 }, (_, i) => arr[i] || "");
      } else if (key === "grafik_vital") {
        this.form.grafik_vital = content[key] || [];
      } else {
        this.form[key] = content[key];
      }
    });
  }

  // ── Grafik vital signs ──────────────────────────────

  getGrafikCellValue(nilai: number, kolom: number): string {
    const entry = this.form.grafik_vital.find(
      e => e.nilai === nilai && e.kolom === kolom
    );
    return entry ? entry.simbol : "";
  }

  onGrafikCellClick(nilai: number, kolom: number) {
    this.grafikDialogNilai = nilai;
    this.grafikDialogKolom = kolom;
    this.grafikDialogSimbol = this.getGrafikCellValue(nilai, kolom);
    this.grafikDialog = true;
  }

  setGrafikCell() {
    // Remove existing entry
    this.form.grafik_vital = this.form.grafik_vital.filter(
      e => !(e.nilai === this.grafikDialogNilai && e.kolom === this.grafikDialogKolom)
    );
    // Add new if not empty
    if (this.grafikDialogSimbol) {
      this.form.grafik_vital.push({
        nilai: this.grafikDialogNilai,
        kolom: this.grafikDialogKolom,
        simbol: this.grafikDialogSimbol
      });
    }
    this.grafikDialog = false;
  }

  // ── Auto-calculate cairan ───────────────────────────

  hitungCairanMasuk() {
    const vals = [
      parseFloat(this.form.cairan_masuk_kristaloid) || 0,
      parseFloat(this.form.cairan_masuk_koloid) || 0,
      parseFloat(this.form.cairan_masuk_komponen) || 0
    ];
    this.form.cairan_masuk_total = vals.reduce((a, b) => a + b, 0).toString();
  }

  hitungCairanKeluar() {
    const vals = [
      parseFloat(this.form.cairan_keluar_darah) || 0,
      parseFloat(this.form.cairan_keluar_urin) || 0
    ];
    this.form.cairan_keluar_total = vals.reduce((a, b) => a + b, 0).toString();
  }

  // ── Helpers ─────────────────────────────────────────

  getUnitId(): string {
    const register = RegisterKunjungan.register;
    if (register && register.jurnal_ranap && register.jurnal_ranap.length) {
      const last = register.jurnal_ranap[register.jurnal_ranap.length - 1];
      if (last && last.unit) return last.unit.id;
    }
    return this.$route && this.$route.query && this.$route.query.unit_id
      ? this.$route.query.unit_id.toString()
      : "";
  }

  getPayload() {
    const { dr_anestesi_user_id, perawat_anestesi_user_id, ...contentFields } = this.form;
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.getUnitId(),
      tanggal: localISODate(),
      dr_anestesi_user_id,
      perawat_anestesi_user_id,
      content: contentFields
    };
  }

  // ── CRUD ────────────────────────────────────────────

  async save() {
    this.saving = true;
    try {
      if (this.recordId) {
        const res = await Service.update(this.recordId, this.getPayload());
        if (res.data?.status === 1) {
          this.record = res.data.data;
        }
      } else {
        const res = await Service.create(this.getPayload());
        if (res.data?.status === 1) {
          this.recordId = res.data.data.id;
          this.record = res.data.data;
        }
      }
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (!confirm("Apakah Anda yakin ingin menghapus data ini?")) return;
    await Service.destroy(this.recordId);
    this.recordId = null;
    this.record = null;
  }

  printPdf() {
    Service.print(this.recordId);
  }

}
